module.exports = __webpack_public_path__ + "static/media/about2.b5b75975.jpg";